import "./lib/env";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { bootApp } from "./boot";
import { initializeSentry } from "./instrumentation-client";
import { router } from "./router";

declare const __OTEL_BROWSER_TRACING__: boolean;

// Imported routes have evaluated before normal reporting takes over.
initializeSentry();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("#root element missing from index.html");
}

// Local tracing: the dev server is started with OTEL_EXPORTER_OTLP_ENDPOINT, the
// same switch the servers use. `import.meta.env.DEV` is false in a production
// build, so the bundler drops the import and the tracing code with it.
bootApp({
  loadTracing:
    import.meta.env.DEV && __OTEL_BROWSER_TRACING__
      ? () => import("./lib/tracing/browser-tracing")
      : undefined,
  mount: () =>
    createRoot(rootEl).render(
      <StrictMode>
        <RouterProvider router={router} />
      </StrictMode>,
    ),
});
